import { useContext, useState } from "react";
import { Modal, Button, Select, Input } from 'antd';
import { CompanyContext } from "../../../../Contexts/CompanyContext";
import { createProjectGroupingAPI } from "../../../../API/ProjectGroupingAPI";
import { IResponseProps } from "../../../../Interfaces/IResponseProps";
import { toast } from "react-toastify";

interface IModalProjectGroupingProps {
    showModal: boolean,
    years: number[],
    toggleShowModal: () => void,
    toggleLoading: (value: boolean) => void,
    getAllGroupingPaginatedByCompanyId: (page: number, year: number) => Promise<void>
}

const ModalProjectGrouping = (props: IModalProjectGroupingProps) => {
    const { company } = useContext(CompanyContext);
    const [name, setName] = useState<string>("");
    const [number, setNumber] = useState<number>();
    const [year, setYear] = useState<number>(0);

    const handleChange = (value: string) => {
        setYear(parseInt(value.toString() ?? "0"))
    }

    function handleClose() {
        setName("");
        setNumber(undefined);
        setYear(0);
        props.toggleShowModal();
    }

    const createGrouping = async () => {
        try {
            props.toggleLoading(true);

            await createProjectGroupingAPI(company.id, number ?? 0, name, year).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success("Agrupamento criado com sucesso!");
                    handleClose();
                    props.getAllGroupingPaginatedByCompanyId(1, 0);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            props.toggleLoading(false);
        }
    }

    return (
        <Modal
            title="Novo Agrupamento"
            onCancel={handleClose}
            open={props.showModal}
            footer={null}
            centered
            closable={true}
            className='modal-container'
        >
            <div className="mt-4">
                <Input
                    onChange={e => setNumber(e.target.value != "" && e.target.value != null && e.target.value != undefined ? parseInt(e.target.value) : 0)}
                    required
                    type="number"
                    value={number}
                    placeholder="Numero de Agrupamento*"
                    className="w-100 mb-2"
                />
                <Input
                    onChange={e => setName(e.target.value)}
                    required
                    value={name}
                    placeholder="Nome do Agrupamento"
                    className="w-100 mt-2 mb-2"
                />
                <Select
                    className="w-100 mt-2"
                    onChange={handleChange}
                    value={year.toString()}
                    options={[
                        { value: '0', label: 'Selecione um ano' },
                        ...props.years.map((year, i) => {
                            return (
                                { value: `${year}`, Label: `${year}` }
                            )
                        })
                    ]}
                />
            </div>
            <div className='btns-delete-modal'>
                <Button
                    type='default'
                    color="default"
                    onClick={handleClose}
                    className='btn-modal-cancel'
                >
                    Cancelar
                </Button>
                <Button
                    type='primary'
                    color="primary"
                    className='btn-modal-confirm'
                    disabled={name == "" || number == undefined || year == 0}
                    onClick={createGrouping}
                >
                    Confirmar
                </Button>
            </div>
        </Modal>
    )
}

export default ModalProjectGrouping;